import { service } from '@/utils/request'

export default {
  // 查询
  getList(params) {
    return service({
      url: `/cloud/activity/admin/activity2025618/vipRenewPopupPages`,
      method: 'get',
      params
    })
  },
  // 详情
  getDetail(params) {
    return service({
      url: `/cloud/activity/admin/activity2025618/vipRenewPopupDetails`,
      method: 'get',
      params
    })
  },
  // 保存
  save(data) {
    return service({
      url: `/cloud/activity/admin/activity2025618/saveVipRenewPopup`,
      method: 'post',
      data
    })
  },
  // 保存
  remove(params) {
    return service({
      url: `/cloud/activity/admin/activity2025618/deleteVipRenewPopup`,
      method: 'post',
      params
    })
  },
  //弹窗状态
  switch(params) {
    return service({
      url: `/cloud/activity/admin/activity2025618/changeStateVipRenewPopup`,
      method: 'post',
      params
    })
  },
  // 查询
  getUserList(params) {
    return service({
      url: `/cloud/activity/admin/activity2025618/userPages`,
      method: 'get',
      params
    })
  },
  // 报名用户导出
  exportUser(params) {
    return service({
      url: `/cloud/activity/admin/activity2025618/exportExcel`,
      method: 'get',
      params,
      responseType: 'blob'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/operateManage/vip_renew.js